import { ITouchScreenplaylistObserverProps } from "interfaces";
import useIntersect from "helpers/hooks/useIntersect";
import { useAppSelector } from "redux-share";
import { shallowEqual } from "react-redux";

const TouchScreenPlaylistObserver = ({ setScrollEnd }: ITouchScreenplaylistObserverProps) => {
    const { playListPopover } = useAppSelector(({ popovers: { playListPopover } }) => ({ playListPopover }), shallowEqual);
    const handleIntersect = ([entry]: IntersectionObserverEntry[]) => {
        if (entry.isIntersecting && playListPopover) setScrollEnd(true);
    };
    const observerRef = useIntersect(handleIntersect);

    return <div id="observer" className="pl-bg-transparent pl-pt-5" ref={observerRef} />;
};

export default TouchScreenPlaylistObserver;
